import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=53f040af&scoped=true"
import script from "./Investment.vue?vue&type=script&lang=js"
export * from "./Investment.vue?vue&type=script&lang=js"
import style0 from "./Investment.vue?vue&type=style&index=0&id=53f040af&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f040af",
  null
  
)

export default component.exports